import styled from "styled-components";

export const AlarmContentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px;
`;

export const LabelTit = styled.p`
  width: 100%;
  font-size: 1.5rem;
  color: ${(props) => props.theme.colors.placeholderTxt};
`;

export const PageContainer = styled.div`
  position: relative;
`;

export const ToggleContainer = styled.div`
  position: relative;
  cursor: pointer;

  .toogleBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .toggle-container {
    width: 54px;
    height: 24px;
    border-radius: 20px;
    background-color: rgba(217, 217, 217, 1);
    transition: 0.5s;
    display: flex;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
    font-weight: 600;
    color: white;
    font-size: 1.25rem;
  }

  .toggle-container.toggle--checked {
    background-color: rgb(0, 50, 255);
    color: white;
  }

  .toggle-circle {
    position: absolute;
    top: 2px;
    left: 1px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: rgb(255, 254, 255);
    transition: 0.3s;
  }

  .toggle-circle.toggle--checked {
    left: 31px;
  }

  .toggleLeft {
    margin-left: 19px;
    margin-top: 2px;
  }
`;

export const CheckBox = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;
